// Centralized brand constants
export const MAGNIFLEX_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_magniflex-hotel-hub/artifacts/r6tbmew2_magniflex-official-logo-it_IT.png";

export const MAGNIFLEX_COLORS = {
  primary: "#003D5C",
  primaryDark: "#002A40",
  accent: "#E30613",
  accentDark: "#B40510",
};

export const MAGNIFLEX_TAGLINE = "Dormire è il piacere più importante.";
